import { mapActions, mapGetters } from 'vuex';
import { STATUS_SUCCESS } from '@/constants/appConstants';
import InteractionService from '@/services/interactionService';

const CLOSE_SIDE_PANELS_EVENT = 'close-side-panels';

export default {
  computed: {
    ...mapGetters('AGENT', ['agentState']),

    ...mapGetters('SETTINGS', ['agentSettings'])
  },

  methods: {
    ...mapActions('INTERACTIONS/emails', ['createOutgoingEmail']),

    async handleCall(phone) {
      if (!phone) {
        const errorMessage = `${this.$t('messages.unableToCall', {
          name: this.contact.name,
          phone: phone.value
        })}`;
        this.emitErrorMessage(errorMessage);
        return;
      }

      if (this.$router.currentRoute.name !== 'Calls') {
        await this.$router.push('calls');
      }

      this.$root.$emit('open-dialpad-number', {
        number: phone.value,
        isPrivateInteraction: this.contact.isInternalContact
      });

      this.$root.$emit(CLOSE_SIDE_PANELS_EVENT);
    },

    async handleEmail(email) {
      if (this.$router.currentRoute.name !== 'Emails') {
        await this.$router.push('emails');
      }
      this.$root.$emit('open-compose-email', this.contact && this.contact.id ? this.contact : null, email.value);
      this.$root.$emit(CLOSE_SIDE_PANELS_EVENT);
    },

    handleChat() {
      const businessProcessId = this.agentSettings.defaultOutgoingCallBusinessProcessId;
      const contact = this.contact;
      const errorMessage = `${this.$t('messages.unableToMessage', this.contact)}`;
      const isPrivateInteraction = this.agentState.isBreak && contact.isInternalContact;

      if (contact.id) {
        // Private interaction flag should be applied ONLY if current agent is on break state
        // BP Should not be included on private mode.
        InteractionService.startChatInteraction({
          businessProcessId: isPrivateInteraction ? undefined : businessProcessId,
          contactId: contact.id,
          isPrivateInteraction
        })
          .then(response => {
            if (
              response &&
              response.status === STATUS_SUCCESS &&
              response.data.interactionId &&
              !/chats/i.test(this.$route.name)
            ) {
              this.$router.push('chats');
            }
          })
          .catch(() => {
            this.emitErrorMessage(errorMessage);
          });
      }
    },

    async handleSMS(phone) {
      if (this.$router.currentRoute.name !== 'Sms') {
        await this.$router.push('sms');
      }
      this.$root.$emit('open-create-sms', (phone && phone.value) || this.contact.endPoint);
      this.$root.$emit(CLOSE_SIDE_PANELS_EVENT);
    },

    emitErrorMessage(message) {
      this.$emit('emit-error-message', {
        message,
        type: 'error'
      });
    }
  }
};
